import React from 'react';

import { useIntl } from 'react-intl';

import { MethodType } from './styled';

const PayPalMethod = () => {
  const { formatMessage } = useIntl();

  return <MethodType>{formatMessage({ id: 'payWithPayPal' })}</MethodType>;
};

export default PayPalMethod;
